import PropTypes from 'prop-types';
import styles from './TabPanel.module.scss';

const TabPanel = ({ children, label, ...props }) => {
    const tabId = ('tab_' + label).replace(/\s+/g, '-');
    return (
        <div { ...props } className={styles.panel} data-module="govuk-tabs" role='tabpanel' id={tabId} aria-labelledby={tabId}>
            {children}
        </div>
    );
};

TabPanel.propTypes = {
    children: PropTypes.any,
    label: PropTypes.string.isRequired
};

TabPanel.defaultProps = {

};

export default TabPanel;
